<template>
  <div class="user-login">
    <el-form :model="userForm" :rules="userRules" ref="userForm" class="login-from">
      <el-form-item prop="user">
        <el-input v-model="userForm.user" placeholder="请输入手机号或邮箱" @focus="clearVerify('userForm', 'user')"></el-input>
      </el-form-item>
      <el-form-item prop="password" class="pwd-item">
        <el-input :type="passwordFlag" v-model="userForm.password" placeholder="请输入密码"
          @focus="clearVerify('userForm', 'password')" @change="pwdError = false" :maxlength="18"></el-input>
        <i :class="['open-pwd', passwordFlag == 'password' ? 'icon1' : 'icon2']" @click="openPwd()"></i>
      </el-form-item>
    </el-form>
    <privacyPolicy :selectFlag="selectFlag" :subshow="subshow" @checkSelect="checkSelect" />
    <div class="login-btn">
      <button @click="login" @keyup.enter="(e) => keyDown(e)">{{ loginName }}</button>
      <p @click="forgetPassword">忘记密码</p>
    </div>
  </div>
</template>

<script>
import { userLogin } from "@/../api";
import { zhugeTrack, jumpAfterLogin } from "@/utils/utils";
import privacyPolicy from "../common/privacy-policy.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "",
  props: ["referUrl", "codeLogin"],
  data() {
    return {
      selectFlag: false, //是否勾选协议
      subshow: false,
      passwordFlag: "password",
      loginName: "登录",
      pawErrMsg: "",
      userForm: {
        user: "",
        password: "",
      },
      userRules: {
        user: [
          { required: true, message: "请输入手机号或邮箱!", trigger: "blur" },
          { validator: this.userValidate, trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { validator: this.pwdvalidator, trigger: "blur" },
        ],
      },
      pwdError: false, // 校验密码是否错误
    };
  },
  watch: {
    isProtocolLogin: {//弹框协议同意并登录
      handler(val) {
        if (val) {
          this.loginYes()
        }
      },
      deep: true,
      immediate: true
    }
  },
  components: {
    privacyPolicy,
  },
  computed: {
    ...mapState(["isToastshow", "message", "manyloginToast", "isProtocolLogin", "protocolDialogVisible"]),
  },
  mounted() {
    window.addEventListener('keydown', this.keyDown)
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyDown, false)
  },
  methods: {
    keyDown(e) {
      if ((e.keyCode == 13 || e.keyCode == 100) && !this.protocolDialogVisible) {//无弹框才enter键才有效

        this.login(e)
      }
    },
    ...mapMutations(["toastshow", "toastHidden", "manyLoginToastshow", "protocolDialogshow", "protocolDialogHidden", "isProtocolLoginYes", "isProtocolLoginNo"]),
    checkSelect() {
      this.selectFlag = !this.selectFlag;
      if (this.selectFlag) {
        this.subshow = false;
      }
    },
    show(message = "默认", duration = 3000) {
      this.toastshow(message);

      const toastTimer = setTimeout(() => {
        this.toastHidden();
        clearTimeout(toastTimer);
      }, duration);
    },

    openPwd() {
      if (this.passwordFlag == "password") {
        this.passwordFlag = "text";
      } else {
        this.passwordFlag = "password";
      }
    },

    userValidate(rule, value, callback) {
      // 邮箱和手机号 校验
      var emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w{2,})*\.\w{2,}([-.]\w{2,})*$/;
      var talReg = /^1\d{10}$/;
      if (value) {
        if (value.indexOf("@") != -1) {
          // 邮箱
          if (!emailReg.test(value)) {
            return callback(new Error("账号格式不正确!"));
          } else {
            callback();
          }
        } else {
          if (!talReg.test(value)) {
            return callback(new Error("账号格式不正确!"));
          } else {
            callback();
          }
        }
      } else {
        return callback(new Error("请输入手机号或邮箱!"));
      }
    },
    pwdvalidator(rule, value, callback) {
      if (this.pwdError) {
        return callback(new Error(this.pawErrMsg));
      } else {
        callback();
      }
    },
    loginYes() {
      //手机登录
      let did = window.zhuge.getDid();
      let sid = window.zhuge.getSid();
      let params = {
        userName: this.userForm.user,
        passWord: this.userForm.password,
        rememberMe: true,
        additional: did + "@" + sid,
      };
      this.loginName = "登录中...";
      this.isProtocolLoginNo()
      userLogin(params).then((res) => {
        let data = res.data;
        if (data.code == 200) {
          localStorage.removeItem(this.userForm.user);
          this.pwdError = false;
          if(data.data.needChangePassword && this.referUrl && this.referUrl.indexOf('match')>-1){//传智杯第一次登陆
             this.$router.push({
                name: "edit-pass",
                query: {
                  refer: this.referUrl ? this.referUrl : undefined
                },
              });
          }else{
              // 登录成功后的跳转
              jumpAfterLogin(this.referUrl);
          }
          
          zhugeTrack("登录成功", {
            终端: 'Web',
            登录方式: "密码",
          });
        }
        //账号密码错误
        else if (data.code == 401) {
          // 存储当前用户的错误次数
          this.pwdError = true;
          this.$refs["userForm"].validateField("password");

          this.pwdError = true;

          this.pawErrMsg = "请输入正确密码，连续输入错误密码，账号将被锁定";
          this.$refs["userForm"].validateField("password");
          this.$refs["userForm"].password = "";
          this.userForm.password = "";
        }
        //说明是邮箱登录但是没有绑定手机号，就去绑定手机号界面307
        else if (data.code == 307) {
          this.$router.push({
            path: "/user/emileBind",
            query: { email: this.userForm.user },
          });
        } else if (data.code == 423) {
          this.manyLoginToastshow();
        } else {
          this.show("登录失败");
        }
        this.loginName = "登录";
      });
    },
    // 用户名登录
    login() {
      // 校验是否多次错误密码
      if (this.loginName != "登录") return;


      this.$refs["userForm"].validate((valid) => {
        if (valid) {

          if (!this.selectFlag && !this.isProtocolLogin) {
            this.protocolDialogshow()
            this.subshow = true;

            return;
          }
          this.loginYes()

        }
      });
      zhugeTrack("点击_登录", {
        '终端': 'Web',
        '登陆方式': "密码"
      });
    },

    // 清除单个表单项验证
    clearVerify(refName, item) {
      this.$refs[refName].clearValidate(item);
    },
    // 忘记密码
    forgetPassword() {
      this.$router.push({
        name: "reset-pass",
        query: {
          refer: this.referUrl ? this.referUrl : undefined,
          codeLogin: this.codeLogin ? this.codeLogin : undefined,
        },
      });
      zhugeTrack("点击_忘记密码", {
        '终端': 'Web'
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.user-login {
  input {
    box-shadow: 0 0 0 1000px white inset !important;
  }

  padding-right: 45px;

  h1 {
    height: 40px;
    font-family: PingFangSC-Regular;
    font-size: 40px;
    color: #2c2c40;
    letter-spacing: 0;
    line-height: 40px;
    font-weight: 400;
  }

  .pwd-item {
    position: relative;

    .open-pwd {
      width: 14px;
      height: 14px;
      position: absolute;
      cursor: pointer;
      top: 50%;
      right: 19px;
      transform: translateY(-50%);
      opacity: 0.6;

      &:hover {
        opacity: 1;
      }

      i {
        line-height: 14px;
      }
    }

    .icon1 {
      background: url("../../assets/login/icon／preview-close\(2\).png");
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      background-size: cover;
      opacity: 1;
    }

    .icon2 {
      background: url("../../assets/login/icon／preview-open.png");
      background-size: 100% 100%;
      width: 16px;
      height: 16px;
      background-size: cover;
      opacity: 1;
    }
  }

  .other-tab {
    margin-top: 25px;
    display: flex;
    justify-content: space-between;

    p {
      height: 14px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      letter-spacing: 0;
      line-height: 14px;
      cursor: pointer;
      white-space: nowrap;
    }
  }

  .privacyPolicy {
    margin-top: 32px;
  }

  .login-btn {
    margin-top: 16px;

    p {
      margin-left: 156px !important;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 22px;
      margin-top: 24px;
      cursor: pointer;
    }
  }
}
</style>
